/**
 * Whether the page has a project to render from, narrowing `value` for the callers that render it.
 *
 * Deliberately ignores `loading`: `useAsyncRetry` keeps `value` while a retry is in flight, so
 * gating content on `loading` blanks already-correct content every time a save refreshes the page.
 */
export function hasFetchedProject<P extends { loading: boolean; value?: unknown }>(
  project: P,
): project is P & { value: NonNullable<P['value']> } {
  return project.value !== undefined;
}
